@if (showLoadingComponent()) {
  <app-loading-page title="PRAXION" [isLoading]="isLoading()"></app-loading-page>
}
<router-outlet></router-outlet>